import { apiGuestSearch } from '../core/redux/api/endpoints';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../core/redux/IAppState';
import { ACTION_TYPE } from '../core/redux/actionType';
import * as R from 'ramda';
import { isNilOrEmpty } from '../language/module';
import ImmutableMap from '../language/ImmutableMap';
import { GuestBasics } from '../guest/guestBasics';


const KEY_ACTION = ACTION_TYPE.GUEST_SEARCH_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GUEST_SEARCH_REQUEST,
  ACTION_TYPE.GUEST_SEARCH_RESPONSE,
  ACTION_TYPE.GUEST_SEARCH_ERROR,
];


/**
 * Constructs a guest search Redux Action for submitting the given query to the REST API
 * @param query - The query to search, this will be escaped for you.
 */
export const guestSearchAction = (query: string, searchTime: Date) => makeApiAction(
  {
    method:   'GET',
    endpoint: state => apiGuestSearch(encodeURIComponent(query), state.userState.userId, state.selectedResort.resortId, searchTime.toISOString()),
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS.map(action => ({ type: action, meta: { query } })) as RsaaTypes,
    // Bail if we're already loading results for that query
    bailout: state => R.path(['guestSearchResults', 'query'], state) === query
      && !!R.path(['guestSearchResults', 'isLoading'], state),
  },
);


const reducer: ApiReducer<GuestBasics[]> = (state, action, error, isLoading, payload): IAppState => {
  const query         = action.meta.query;
  const appStateQuery = R.path<string>(['guestSearchResults', 'query'], state);

  // If we're getting a search response for a different query (likely a previous query that didn't complete before the
  // user searched again), ignore the search results.
  if (action.type === ACTION_TYPE.GUEST_SEARCH_RESPONSE && !isNilOrEmpty(appStateQuery) && appStateQuery !== query) {
    return state;
  }

  return ({
    ...state,
    guests:               ImmutableMap.empty(),
    entitlementHotlists:  ImmutableMap.empty(),
    households:           [],
    importSuccesses:      [],
    mediaHistories:       [],
    guestResortHistories: ImmutableMap.empty(),
    commentHistories:     [],
    paymentGuests:        [],
    guestSearchResults:   {
      query:     query,
      isLoading: isLoading,
      results:   payload,
      error:     error,
    },
  });
};


export const guestSearchReducer = makeApiReducer<GuestBasics[]>(ACTIONS, KEY_ACTION, reducer);

